
if (!customElements.get('bundle-add')) {
    class BundleAdd extends HTMLElement {
        constructor() {
            super();

            this.miniCart = document.querySelector('mini-cart');
            this.button = this.querySelector('button');
            if (this.button) this.button.addEventListener('click', this.onButtonClick.bind(this));
        }

        /* 更新显示更高价格 */
        updatePrice() {
            const products = [...this.querySelectorAll('bundle-product-info')];

            const highest = products.reduce((max, item) => {
                const price = Number(item.dataset.price);

                if (!max || price > Number(max.dataset.price)) {
                    return item;
                }

                return max;
            }, null);

            if (!highest) return;

            const display = this.querySelector('.bundle-price-wrapper .inner');
            const price = highest.querySelector('[id^="price-"]');

            if (display && price) {
                display.innerHTML = price.innerHTML;
            }
        }

        onButtonClick(event) {
            event.preventDefault();

            const ids = [...this.querySelectorAll('[name="id"]')].filter(el => el.closest('.variant-selector')?.offsetParent !== null);//offsetParent 过滤掉不显示的input

            const items = {
                items: [...ids].map((e => e.value)).map((e => ({
                    id: e,
                    quantity: 1
                })))
            };

            if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
                Shopify.postLink2(theme.routes.cart_add_url, {
                    parameters: {
                        ...items
                    }
                });
                return;
            }

            this.handleErrorMessage();

            this.button.setAttribute('disabled', true);
            this.button.classList.add('loading');
            const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

            const body = JSON.stringify({
                ...items,
                sections: sections,
                sections_url: window.location.pathname
            });

            fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
                        return;
                    }

                    if (response.status === 422) {
                        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                            detail: {
                                errorMessage: response.description
                            }
                        }));
                    }
                    else {
                        this.miniCart && this.miniCart.renderContents(response);

                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: response
                            }
                        }));
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.button.classList.remove('loading');
                    this.button.removeAttribute('disabled');
                });
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

            if (this.errorMessageWrapper) {
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
            else {
                if (errorMessage) {
                    alert(errorMessage);
                }
            }
        }
    }
    customElements.define('bundle-add', BundleAdd);
}

if (!customElements.get('bundle-product-info')) {
    class BundleProductInfo extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];

        constructor() {
            super();

            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueSelectionChange,
                this.handleOptionValueChange.bind(this)
            );
        }

        disconnectedCallback() {
            this.onVariantChangeUnsubscriber();
        }

        handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
            if (!this.contains(event.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
            this.pendingRequestUrl = productUrl;
            const shouldSwapProduct = (this.dataset.url !== productUrl) || this.querySelector('li[data-gang-option]') !== null;

            console.log('showSwap', shouldSwapProduct);
            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: target.id,
                callback: shouldSwapProduct
                    ? this.handleSwapProduct(productUrl)
                    : this.handleUpdateProductInfo(productUrl),
            });
        }

        handleSwapProduct(productUrl) {
            return (html) => {

                const selector = `bundle-product-info[data-block="${this.dataset.block}"]`;
                HTMLUpdateUtility.viewTransition(
                    this,
                    html.querySelector(selector),
                    this.preProcessHtmlCallbacks,
                    this.postProcessHtmlCallbacks
                );

            };
        }

        renderProductInfo({ requestUrl, targetId, callback }) {
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
                .then((response) => response.text())
                .then((responseText) => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    callback(html);
                })
                .then(() => {
                    // set focus to last clicked option value
                    document.querySelector(`#${targetId}`)?.focus();
                })
                .catch((error) => {
                    if (error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    } else {
                        console.error(error);
                    }
                });
        }

        getSelectedVariant(productInfoNode) {
            const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
            return !!selectedVariant ? JSON.parse(selectedVariant) : null;

        }

        buildRequestUrlWithParams(url, optionValues) {
            const params = [];

            params.push(`section_id=${this.sectionId}`);
            if (optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }

            return `${url}?${params.join('&')}`;
        }

        updateOptionValues(html) {
            const source = html.querySelector(`bundle-product-info[data-block="${this.dataset.block}"]`);
            const variantSelects = source.querySelector('variant-selects[data-primary]');
            if (variantSelects) {
                HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
            }
        }

        updateVariantInputs(variantId) {

            const input = this.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        handleUpdateProductInfo(productUrl) {
            return (html) => {
                const source = html.querySelector(`bundle-product-info[data-block="${this.blockId}"]`);
                const variant = this.getSelectedVariant(source);

                this.updateOptionValues(html);
                this.updateVariantInputs(variant?.id);

                if (!variant) return;


                // 保存当前产品价格（单位 cents）
                this.dataset.price = variant.price;

                const updateSourceFromDestination = (id, shouldHide = (source) => false) => {

                    const source = html.getElementById(`${id}-${this.blockId}`);
                    const destination = this.querySelector(`#${id}-${this.dataset.block}`);
                    if (source && destination) {
                        destination.innerHTML = source.innerHTML;
                        destination.classList.toggle('hidden', shouldHide(source));
                    }
                };

                updateSourceFromDestination('price');

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId: this.sectionId,
                        html,
                        variant,
                    },
                });

                /* 修改bundle价格 */
                const bundle = this.closest('bundle-add');
                bundle?.updatePrice();


            };
        }

        get variantSelectors() {
            const selector = this.querySelector(`variant-selects[data-block="${this.blockId }"]`)
            return selector;
        }

        get sectionId() {
            return this.dataset.originalSection || this.dataset.section;
        }
        get blockId() {
            return this.dataset.block;
        }


    }
    customElements.define('bundle-product-info', BundleProductInfo);
}